import React from 'react';

import styles from './Navigation.module.css'
import { Icon } from "../../ui/General/Icon/Icon.tsx";
import { Cart } from "../Cart/Cart.tsx";
import { Login } from "../Login/Login.tsx";

export const Navigation: React.FC = () => {
    /** Переход на главную страницу */
    const goHome = () => {
        if (typeof window !== 'undefined') {
            window.location.href = '/';
        }
    };
    
    return (
        <>
            <div className={styles.fakeBlock}></div>
            <nav className={styles.container}>
                <ul className={styles.list}>
                    <li className={styles.item} onClick={goHome}>
                        <Icon name='main' width={24} height={24} />
                        <span className={styles.link}>
                            Главная
                        </span>
                    </li>
                    <li className={styles.item}>
                        <a href="javascript:jivo_api.open()" className={styles.link}>
                            <Icon name='support' width={28} height={24} style={{ margin: 'auto', marginBottom: 5, }} />
                            Помощь
                        </a>
                    </li>
                    <li className={styles.item}>
                        <Cart />
                    </li>
                    <li className={styles.item}>
                        <Icon name='search' width={24} height={24} color='#fff' />
                        <a href="" className={styles.link}>
                            Каталог
                        </a>
                    </li>
                    <li className={styles.item}>
                        <Login />
                    </li>
                </ul>
            </nav>
        </>
    );
};